__turbopack_context__.v({
  "button": "ContactUs-module-scss-module__YBMfwq__button",
  "buttonContainer": "ContactUs-module-scss-module__YBMfwq__buttonContainer",
  "contactData": "ContactUs-module-scss-module__YBMfwq__contactData",
  "container": "ContactUs-module-scss-module__YBMfwq__container",
  "containerFullWidth": "ContactUs-module-scss-module__YBMfwq__containerFullWidth",
  "content": "ContactUs-module-scss-module__YBMfwq__content",
  "contentWrapper": "ContactUs-module-scss-module__YBMfwq__contentWrapper",
  "contentWrapperSubtle": "ContactUs-module-scss-module__YBMfwq__contentWrapperSubtle",
  "hours": "ContactUs-module-scss-module__YBMfwq__hours",
  "iconWrapper": "ContactUs-module-scss-module__YBMfwq__iconWrapper",
  "item": "ContactUs-module-scss-module__YBMfwq__item",
  "subtitle": "ContactUs-module-scss-module__YBMfwq__subtitle",
  "title": "ContactUs-module-scss-module__YBMfwq__title",
});
